var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2H8H9ZM7 6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6H8H7ZM17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2H16H17ZM15 6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6H16H15ZM6 4V5H18V4V3H6V4ZM21 7H20V19H21H22V7H21ZM18 22V21H6V22V23H18V22ZM3 19H4V7H3H2V19H3ZM6 22V21C4.89543 21 4 20.1046 4 19H3H2C2 21.2091 3.79086 23 6 23V22ZM21 19H20C20 20.1046 19.1046 21 18 21V22V23C20.2091 23 22 21.2091 22 19H21ZM18 4V5C19.1046 5 20 5.89543 20 7H21H22C22 4.79086 20.2091 3 18 3V4ZM6 4V3C3.79086 3 2 4.79086 2 7H3H4C4 5.89543 4.89543 5 6 5V4ZM3 10V11H21V10V9H3V10ZM8 2H7V6H8H9V2H8ZM16 2H15V6H16H17V2H16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6c1ebfb00f8dfa7c54793c0dcfd13284.svg";
export { ForwardRef as ReactComponent };